import React from 'react';
import { Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import './styles.css';

export default function Cards({
  imgCard1,
  spanCard1,
  linkCard1,
  imgCard2,
  spanCard2,
  linkCard2,
}) {
  return (
    <>
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-6 align-self-center">
            <div className="row justify-content-center">
              <div className="card">
                <button type="submit">
                  <Link to={linkCard1}>
                    <img src={imgCard1} alt="" />
                  </Link>
                </button>
              </div>
            </div>
            <div className="row justify-content-center">
              <span>{spanCard1}</span>
            </div>
          </div>
          <div className="col-6 align-self-center">
            <div className="row justify-content-center">
              <div className="card">
                <button type="submit">
                  <Link to={linkCard2}>
                    <img src={imgCard2} alt="" />
                  </Link>
                </button>
              </div>
            </div>
            <div className="row justify-content-center">
              <span>{spanCard2}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
